import http from '@/components/services/http-common';
import formatter from '@/components/services/formatter';

// employeeReviews/condition API
export const gets = (params = {}) =>
  http
    .get('it/permissions', { params })
    .then(res => {
      res.data.data= res.data.data.map(x => {
        x.createdAt = formatter.formatDate(x.createdAt, "HH:mm:ss DD/MM/YYYY")
        return x
      })
      return res.data
    })

export const get = id => http.get(`it/permissions/${id}`).then(res => res.data);

export const post = (payload) => http.post('it/permissions', payload);

export const put = (id, payload) =>{
  console.log('debug-payload:', payload)
  return  http.put(`it/permissions/${id}`, payload)
};

export const remove = id => http.delete(`it/permissions/${id}`);
